function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3000 2000",
    style: {
      enableBackground: "new 0 0 3000 2000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 3000,
    height: 2000
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#E4E4E4",
      strokeWidth: 4,
      strokeMiterlimit: 10,
      strokeDasharray: "32.0882,32.0882"
    },
    d: "M2712,1308 c125.272,224.172-56,664-1205.639,358.328c-576.411-153.259-1006.971,191.99-1095.695-48.995 C204,1056,1048,406.667,1517.333,860C1946.328,1274.369,2484,900,2712,1308z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6F5F5"
    },
    d: "M2705.4,1801.444H361.32c73.36-542,570.08-961.24,1172.04-961.24 C2135.28,840.204,2632.04,1259.444,2705.4,1801.444z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A9BAE6"
    },
    d: "M2399.846,1796.677h-881.681c-41.048,0-74.325-33.276-74.325-74.325V457.646 c0-41.048,33.276-74.325,74.325-74.325h881.681c41.048,0,74.325,33.276,74.325,74.325v1264.707 C2474.171,1763.401,2440.895,1796.677,2399.846,1796.677z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1536.96,
    y: 440.28,
    style: {
      fill: "#F6F5F5"
    },
    width: 848.04,
    height: 1231.88
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4E4E4"
    },
    d: "M2384.999,440.287c0.265,480.366,15.772,1059.713-38.185,1187.984 c-237.668,23.156-515.955,30.588-809.865,31.971L1648.669,444L2384.999,440.287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2308.829,1589.454c-370.44,59.286-618.024,62.412-818.827,47.502 c26.023-277.004,36.453-737.178,46.946-1196.613l446.387,0.991l404,26.667 C2393.223,944.848,2393.867,1385.319,2308.829,1589.454z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1730.958,
    y: 559.128,
    transform: "matrix(0.9997 0.0235 -0.0235 0.9997 14.4959 -45.8121)",
    style: {
      fill: "#708CD5"
    },
    width: 446.244,
    height: 67.972
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1861.121,
    y: 725.935,
    transform: "matrix(0.9997 0.0235 -0.0235 0.9997 18.017 -48.3191)",
    style: {
      fill: "#708CD5"
    },
    width: 402.51,
    height: 31.112
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1859.543,
    y: 792.236,
    transform: "matrix(0.9997 0.0235 -0.0235 0.9997 19.559 -46.7477)",
    style: {
      fill: "#D3DFFF"
    },
    width: 273.593,
    height: 31.112
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1638.35,
    y: 718.916,
    transform: "matrix(0.9997 0.0235 -0.0235 0.9997 18.5028 -39.4568)",
    style: {
      fill: "#FFFFFF",
      stroke: "#708CD5",
      strokeWidth: 6,
      strokeMiterlimit: 10
    },
    width: 95.289,
    height: 95.289
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EE6F57"
    },
    d: "M1655.011,742.875c2.941,11.26,8.373,58.424,31.992,45.236 c5.446-3.041,10.059-11.082,14.133-15.707c7.324-8.316,14.648-16.631,21.973-24.947 c14.648-16.631,29.297-33.262,43.945-49.894c3.754-4.262-12.822-14.952-17.535-9.602 c-13.021,14.783-26.042,29.567-39.062,44.35c-6.51,7.392-13.021,14.783-19.531,22.175 c-4.519,5.13-14.965,21.675-21.67,23.142c3.645,1.177,7.291,2.355,10.936,3.532c2.576,2.114-2.21-12.87-2.316-13.277 c-1.817-6.956-3.634-13.913-5.45-20.869C1670.923,741.268,1652.787,734.359,1655.011,742.875L1655.011,742.875z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1857.055,
    y: 898.29,
    transform: "matrix(0.9997 0.0235 -0.0235 0.9997 22.0613 -47.3398)",
    style: {
      fill: "#708CD5"
    },
    width: 331.46,
    height: 31.112
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1855.449,
    y: 966.944,
    transform: "matrix(0.9997 0.0235 -0.0235 0.9997 23.686 -48.1189)",
    style: {
      fill: "#D3DFFF"
    },
    width: 402.51,
    height: 31.112
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1634.274,
    y: 892.107,
    transform: "matrix(0.9997 0.0235 -0.0235 0.9997 22.5766 -39.3129)",
    style: {
      fill: "#FFFFFF",
      stroke: "#708CD5",
      strokeWidth: 6,
      strokeMiterlimit: 10
    },
    width: 95.289,
    height: 95.289
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EE6F57"
    },
    d: "M1650.871,918.753c2.941,11.26,8.373,58.425,31.992,45.236 c5.446-3.041,10.059-11.082,14.133-15.707c7.324-8.316,14.648-16.631,21.973-24.947 c14.648-16.631,29.297-33.262,43.945-49.894c3.754-4.262-12.822-14.952-17.535-9.602 c-13.021,14.783-26.042,29.567-39.063,44.35c-6.51,7.392-13.021,14.783-19.531,22.175 c-4.519,5.13-14.965,21.675-21.67,23.142c3.645,1.177,7.291,2.355,10.936,3.532c2.576,2.114-2.21-12.87-2.316-13.277 c-1.817-6.956-3.634-13.913-5.45-20.869C1666.784,917.146,1648.647,910.237,1650.871,918.753L1650.871,918.753z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1852.969,
    y: 1072.317,
    transform: "matrix(0.9997 0.0235 -0.0235 0.9997 26.1649 -48.0319)",
    style: {
      fill: "#708CD5"
    },
    width: 402.51,
    height: 31.112
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1851.404,
    y: 1137.517,
    transform: "matrix(0.9997 0.0235 -0.0235 0.9997 27.6672 -45.3588)",
    style: {
      fill: "#D3DFFF"
    },
    width: 180.009,
    height: 31.112
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1630.198,
    y: 1065.298,
    transform: "matrix(0.9997 0.0235 -0.0235 0.9997 26.6504 -39.1691)",
    style: {
      fill: "#FFFFFF",
      stroke: "#708CD5",
      strokeWidth: 6,
      strokeMiterlimit: 10
    },
    width: 95.289,
    height: 95.289
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EE6F57"
    },
    d: "M1648.088,1093.174c2.941,11.26,8.373,58.425,31.992,45.236 c5.446-3.041,10.059-11.082,14.133-15.707c7.324-8.316,14.648-16.631,21.973-24.947 c14.648-16.631,29.297-33.262,43.945-49.894c3.754-4.262-12.822-14.952-17.535-9.602 c-13.021,14.783-26.042,29.567-39.062,44.35c-6.51,7.392-13.021,14.783-19.531,22.175 c-4.519,5.13-14.965,21.675-21.67,23.142c3.645,1.177,7.291,2.355,10.936,3.532c2.576,2.114-2.21-12.87-2.316-13.277 c-1.817-6.957-3.634-13.913-5.45-20.869C1664.001,1091.568,1645.864,1084.658,1648.088,1093.174L1648.088,1093.174z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1848.893,
    y: 1245.508,
    transform: "matrix(0.9997 0.0235 -0.0235 0.9997 30.2383 -47.8876)",
    style: {
      fill: "#708CD5"
    },
    width: 402.51,
    height: 31.112
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1847.309,
    y: 1312.331,
    transform: "matrix(0.9997 0.0235 -0.0235 0.9997 31.7986 -46.8374)",
    style: {
      fill: "#D3DFFF"
    },
    width: 317.968,
    height: 31.112
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1626.122,
    y: 1238.489,
    transform: "matrix(0.9997 0.0235 -0.0235 0.9997 30.7242 -39.0252)",
    style: {
      fill: "#FFFFFF",
      stroke: "#708CD5",
      strokeWidth: 6,
      strokeMiterlimit: 10
    },
    width: 95.289,
    height: 95.289
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EE6F57"
    },
    d: "M1644.039,1265.229c2.941,11.26,8.373,58.425,31.992,45.236 c5.446-3.041,10.059-11.082,14.133-15.707c7.324-8.316,14.648-16.631,21.973-24.947 c14.648-16.631,29.297-33.263,43.945-49.894c3.754-4.262-12.822-14.953-17.535-9.602 c-13.021,14.783-26.042,29.567-39.062,44.35c-6.51,7.392-13.021,14.783-19.531,22.175 c-4.519,5.13-14.965,21.675-21.67,23.142c3.645,1.177,7.291,2.355,10.936,3.532c2.576,2.114-2.21-12.87-2.316-13.277 c-1.817-6.956-3.634-13.913-5.45-20.869C1659.952,1263.622,1641.815,1256.713,1644.039,1265.229L1644.039,1265.229z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1844.882,
    y: 1414.531,
    transform: "matrix(0.9997 0.0235 -0.0235 0.9997 34.1799 -44.8875)",
    style: {
      fill: "#708CD5"
    },
    width: 159.554,
    height: 31.112
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D3DFFF"
    },
    d: "M2246.072,1489.946l-402.398-9.47l-0.732,31.104c155.683,3.653,353.91,10.946,394.357,4.74 C2243.438,1509.339,2246.75,1500.766,2246.072,1489.946z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1623.409,
    y: 1410.401,
    transform: "matrix(0.9997 0.0235 -0.0235 0.9997 34.7682 -38.9138)",
    style: {
      fill: "#FFFFFF",
      stroke: "#708CD5",
      strokeWidth: 6,
      strokeMiterlimit: 10
    },
    width: 95.289,
    height: 95.289
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EE6F57"
    },
    d: "M1640.025,1435.777c2.941,11.26,8.373,58.424,31.992,45.236 c5.446-3.041,10.059-11.082,14.133-15.707c7.324-8.316,14.648-16.631,21.973-24.947 c14.648-16.631,29.297-33.262,43.945-49.894c3.754-4.262-12.822-14.952-17.535-9.602 c-13.021,14.783-26.042,29.567-39.062,44.35c-6.51,7.392-13.021,14.783-19.531,22.175 c-4.519,5.13-14.965,21.675-21.67,23.142c3.645,1.177,7.291,2.355,10.936,3.532c2.576,2.114-2.21-12.87-2.316-13.277 c-1.817-6.956-3.634-13.913-5.45-20.869C1655.938,1434.171,1637.801,1427.261,1640.025,1435.777L1640.025,1435.777z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EE6F57"
    },
    d: "M2150,391.88v95.08h-382v-95.08c0-15.16,6.16-28.88,16.08-38.84c1.24-1.24,2.52-2.4,3.88-3.48 c9.48-7.88,21.68-12.6,34.96-12.6c9.96,0,19.52-2.28,28.08-6.4c3.72-1.8,7.24-3.92,10.56-6.36 c10.92-8.08,19.28-19.56,23.44-33.24c4.24-13.96,12.92-25.64,24.16-33.76c10.8-7.76,23.96-12.24,37.92-12.24h23.84 c13.96,0,27.12,4.48,37.92,12.24c11.24,8.12,19.92,19.8,24.16,33.76c4.16,13.68,12.52,25.16,23.44,33.24 c3.32,2.44,6.84,4.56,10.56,6.36c8.56,4.12,18.12,6.4,28.08,6.4c13.28,0,25.48,4.72,34.96,12.6 C2142.24,359.6,2150,374.84,2150,391.88z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E4E4E4"
    },
    points: "2181,440.28 2181,510.96 1737,510.96 1737,440.28 1768,440.28 1768,486.96 2150,486.96  2150,440.28  "
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 1959.006,
    cy: 301.953,
    rx: 33.883,
    ry: 32.203
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9B384"
    },
    d: "M1226.922,747.089c-13.549-2.563-26.213-25.201-30.614-33.881 c-1.081-2.132-1.417-4.54-0.974-6.889l5.392-28.58c0,0,12.442,2.115,11.48,18.684c-0.1,1.72,0.252,3.436,0.867,5.045 l4.763,12.461l14.082-10.902l-7.722-21.804c0,0-10.334,2.839-15.672,1.136c-10.956-3.497,3.407-12.038,7.95-12.946 c4.543-0.909,14.536-4.543,19.079,3.18c4.542,7.722,7.268,12.265,7.268,12.265s4.997-17.262,1.59-55.874 c-0.153-1.737,4.2-1.7,5.422-0.456c3.658,3.722,9.485,15.055,9.796,49.516c0,0,0.609-40.159,7.495-44.29 c5.678-3.407,8.546,16.248,4.546,49.582c0,0,7.413-28.862,12.716-28.913c8.951-0.087,0.118,77.08-22.382,100.08 L1226.922,747.089z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9B384"
    },
    d: "M1269.403,735.28c-0.4,3.84-0.84,7.56-1.32,11.16v0.04c-1.6,12.8-3.6,24.24-5.92,34.04 c-0.12,0.48-0.2,0.92-0.32,1.36c-6.84,28.04-8.08,41.76-31.44,38.08l-24.04-27.36l-0.24-0.28l-1.76-2l4.88-14.4l0.64-1.88 l3.6-10.48l0.44-1.36l6.16-18.04l2.48-7.32L1269.403,735.28z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1F3C88"
    },
    d: "M822.789,1731.542l-6.12,19.125c-41.959,13.784-66.432,29.577-68,48h121.333l9.727-64.034 C855.155,1740.628,835.463,1736.456,822.789,1731.542z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9B384"
    },
    d: "M838.003,1684l-15.213,47.542c12.673,4.914,32.366,9.086,56.94,3.09l6.273-41.299L838.003,1684z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9B384"
    },
    d: "M1045.442,1729.423l3.56-48.423l-57,3l-3.114,44.639 C1013.021,1736.332,1032.966,1733.321,1045.442,1729.423z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1F3C88"
    },
    d: "M1114.003,1798.667c-1.568-18.423-23-43.667-70-49.667l1.44-19.577 c-12.476,3.898-32.421,6.909-56.554-0.784l-4.886,70.028H1114.003z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F9B384"
    },
    points: "999.243,759.52 930.483,760 930.483,656 997.163,656 997.203,662.36 997.523,695.32  998.003,748.24  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E28B6D"
    },
    d: "M997.523,700.32c-12.36,13-44.6-1.68-58.2-16l57.88-16.96L997.523,700.32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9B384"
    },
    d: "M1013.483,632c-0.04,7.68-0.52,15.72-1.8,23.4c-3.36,20.96-12.24,39.08-32.72,39.64 c-48.4,1.4-62.2-26.28-71.32-48.92c-9.12-22.68,5.68-77.2,5.68-77.2l62.64-6.2l34.4,28.2 C1010.363,590.92,1013.683,610.08,1013.483,632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#102048"
    },
    d: "M909.594,633.154c0,0,13.809-0.637,16.168-36.278c24.691,8.263,42.734,0.729,57.03-15.714 c12.199,16.111,46.345,21.156,57.878-11.829c8.333-23.833-14.667-59.333-48.167-37.833 c-32.831-16.586-82.628-15.449-96.958,25.239c0,0-49.817,22.968,2.931,73.54C899.534,631.293,909.594,633.154,909.594,633.154z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#102048"
    },
    points: "1100.009,1133.3 1062.003,1708 972.669,1708 995.003,1150.333 1008.669,1144  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#1F3C88"
    },
    points: "867.336,1054.667 804.669,1708 902.003,1708 994.669,1165.333 1100.003,1133.333  1104.669,1017.333 870.003,1012  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#102048"
    },
    d: "M881.309,1056.093c53.164,19.085,177.896-2.726,203.796-29.308l-18.403-36.806 l-205.16,27.264L881.309,1056.093z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1080.323,1017.92c-1.72,0.72-3.48,1.48-5.28,2.16c-19.88,8.08-42.52,15.16-66.64,19.84 c-14.4,2.84-29.4,4.76-44.68,5.48c-23.04,1.16-46.72-0.36-70.16-5.68l29.8-277.84l3.64-33.88c0,0,39,48,82-5L1080.323,1017.92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#1F3C88"
    },
    d: "M963.723,1045.4c-23.04,1.16-46.72-0.36-70.16-5.68l29.8-277.84l10.64-15.38 C960.283,810.42,987.203,951.96,963.723,1045.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#708CD5"
    },
    d: "M930.503,717c29.629,125.802,41.821,255.252-1.833,399 c-32.372,12.315-67.618,12.175-105.333,1.333L832.669,856l-219.667,151l-13.333-82.333 C684.111,843.925,830.109,721.948,930.503,717z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#1F3C88"
    },
    d: "M1075.043,1020.08c-19.88,8.08-42.52,15.16-66.64,19.84 c-13.24-75.92-16.16-200.64-5.4-256.92L1075.043,1020.08z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#E28B6D"
    },
    d: "M1262.163,780.52c-0.12,0.48-0.2,0.92-0.32,1.36c-6.84,28.04-8.08,41.76-31.44,38.08 l-24.04-27.36l-0.24-0.28l3.12-16.4l0.64-1.88l3.6-10.48l0.44-1.36L1262.163,780.52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#708CD5"
    },
    d: "M1258.003,806c0,0-59,125-94,128c-33.93,2.908-50-30-50-30l24,182.68 c-28.2,13.2-58.96,19.64-94.68,13.32c-31.72-103-43.71-236.18-46.07-384.5c25.68,1.6,76.54,3.794,94.75,15.5 c32.667,21,73,96,73,96l47-64L1258.003,806z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6F3428"
    },
    d: "M538.744,629.874c0,0,3.571-59.798,9.657-56.976c6.086,2.822,18.292,54.818,18.292,54.818 l-13.051,21.061L538.744,629.874z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EE6F57"
    },
    d: "M718.3,1709.667l1.768,19.681c3.121,34.74-22.515,65.437-57.255,68.559l-5.059,0.454 c-34.74,3.121-65.437-22.515-68.559-57.255l-1.768-19.681L718.3,1709.667z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 544.355,
    y: 760.666,
    transform: "matrix(0.996 -0.0895 0.0895 0.996 -108.4282 59.5604)",
    style: {
      fill: "#FBC343"
    },
    width: 131.4,
    height: 956.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 579.708,
    y: 741.794,
    transform: "matrix(0.996 -0.0895 0.0895 0.996 -101.4825 58.6203)",
    style: {
      opacity: 0.3,
      fill: "none",
      stroke: "#6F3428",
      strokeWidth: 8,
      strokeMiterlimit: 10
    },
    width: 46.667,
    height: 838.667
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#102048"
    },
    points: "718.283,1709.68 587.443,1721.44 584.003,1683.04 581.603,1656.36 574.203,1574.36  705.083,1562.6 712.443,1644.6 714.843,1671.28  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 582.539,
    y: 1650.426,
    transform: "matrix(0.996 -0.0895 0.0895 0.996 -146.3423 64.709)",
    style: {
      fill: "#FBC343"
    },
    width: 131.367,
    height: 26.788
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EE6F57"
    },
    d: "M501.793,768.467l36.353-145.692c0,0,12.548,5.566,27.768-3.833l66.762,137.767L501.793,768.467z "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9B384"
    },
    d: "M916.835,627.123c-0.586-2.149-10.352-5.103-12.505-5.698c-3.326-0.919-6.955-1.371-10.2,0.095 c-11.811,5.336-10.233,22.25-4.114,31.138c3.467,5.036,8.542,8.91,14.445,10.601c2.145,0.614,22.463,0.857,21.572-2.409 C926.029,660.836,916.854,627.196,916.835,627.123z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9B384"
    },
    d: "M545.003,967c-3.07-9.635-13.169-15.042-22.727-11.742c-14.888,5.14-27.855,13.863-29.864,28.698 c-1.829,13.511,4.928,56.668,35.11,62.212l-2.464-22.174c0,0,18.479-4.312,22.174-12.319 C549.819,1006.068,549.991,982.656,545.003,967z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1F3C88"
    },
    d: "M1104.779,818.576c1.587,9.444,2.938,18.916,4.234,28.395c1.342,9.473,2.407,18.978,3.624,28.466 l3.101,28.527c0.904,9.524,1.789,19.051,2.375,28.612l-1.553,0.182c-1.636-9.439-2.974-18.912-4.292-28.388l-3.566-28.473 c-1.005-9.512-2.162-19.007-3.043-28.534c-0.926-9.522-1.797-19.05-2.432-28.605L1104.779,818.576z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1F3C88"
    },
    d: "M835.784,817.037c-0.021,10.606-0.28,21.201-0.594,31.793 c-0.268,10.594-0.814,21.175-1.208,31.764l-1.734,31.739c-0.708,10.573-1.436,21.146-2.464,31.704l-1.562-0.074 c-0.028-10.608,0.244-21.202,0.536-31.796l1.266-31.761c0.607-10.578,1.06-21.164,1.792-31.736 c0.686-10.574,1.427-21.146,2.406-31.707L835.784,817.037z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#102048"
    },
    d: "M965.379,626.129c0.845,3.772-0.708,7.332-3.47,7.951c-2.762,0.619-5.686-1.938-6.532-5.71 c-0.845-3.772,0.708-7.332,3.47-7.951C961.609,619.8,964.533,622.357,965.379,626.129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#102048"
    },
    d: "M1005.248,621.467c-0.164,3.863-2.589,6.897-5.417,6.777c-2.828-0.12-4.988-3.348-4.824-7.211 c0.163-3.863,2.589-6.897,5.417-6.777C1003.252,614.376,1005.412,617.604,1005.248,621.467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E28B6D"
    },
    d: "M983.017,624.635c1.371,3.305,1.154,6.869,2.039,9.579c0.452,1.37,1.075,2.575,1.937,3.325 c0.803,0.731,2.103,1.207,3.753,1.846c1.7,0.658,3.506,1.83,4.74,3.57c1.308,1.693,1.669,4.627,0.485,6.546 c-1.064,1.922-2.595,2.976-3.909,3.953c-1.373,0.925-2.693,1.91-4.118,2.775l-1.028-1.178c1.049-1.295,2.205-2.47,3.307-3.705 c1.137-1.17,2.181-2.313,2.583-3.368c0.848-1.851-0.965-3.874-3.591-4.92c-1.353-0.617-3.302-1.16-4.876-2.768 c-1.517-1.548-2.266-3.483-2.567-5.289c-0.661-3.706,0.095-6.876-0.264-9.958L983.017,624.635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#102048"
    },
    d: "M946.294,616.002c0.59-2.374,2.036-4.617,4.083-6.236c2.013-1.673,4.644-2.579,7.251-2.714 c5.252-0.318,10.452,2.67,12.612,7.086l-1.225,0.972c-3.473-2.726-7.298-4.224-11.195-4.082 c-3.909,0.104-7.456,2.114-10.109,5.635L946.294,616.002z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#102048"
    },
    d: "M987.579,611.103c0.59-1.852,1.631-3.608,3.14-5.053c1.476-1.483,3.536-2.459,5.677-2.81 c4.297-0.711,8.914,1.475,10.607,5.291l-1.251,0.938c-2.813-1.888-5.876-2.689-8.768-2.292c-1.447,0.194-2.821,0.737-4.178,1.528 c-1.334,0.832-2.55,1.969-3.88,3.193L987.579,611.103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M965.452,663.373c6.984,10.931,16.29,12.12,23.477,0.614L965.452,663.373z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#FC8879"
    },
    d: "M1013.669,629.333c-0.04,7.68-0.707,18.387-1.987,26.067 c-4.84-1.56-8.36-6.08-8.36-11.48C1003.323,637.88,1007.949,630.253,1013.669,629.333z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 0.4,
      fill: "#FC8879"
    },
    cx: 948.402,
    cy: 651.066,
    r: 12.899
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E28B6D"
    },
    d: "M908.38,639.973c-2.548-1.73-4.886-3.625-7.213-4.748c-1.153-0.567-2.225-0.908-3.182-0.826 c-0.965,0.069-2.077,0.636-3.327,1.526l-1.313-0.849c0.544-1.596,1.692-3.39,3.8-4.087c2.094-0.725,4.217-0.141,5.788,0.669 c3.185,1.739,5.365,4.304,6.691,7.37L908.38,639.973z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#6F3428"
    },
    d: "M547.232,1011.674l-18.565,56.41L524.833,1024 C536.37,1021.489,542.67,1016.869,547.232,1011.674z"
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#102048",
      strokeWidth: 8,
      strokeMiterlimit: 10
    },
    x1: 240.425,
    y1: 1799.034,
    x2: 2826.295,
    y2: 1799.034
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.b99a1d38564945d0abe927b7761d0c8e.svg";
export { ForwardRef as ReactComponent };